import React from "react";
import { Link } from "gatsby";
import {
  FaShieldAlt,
  FaUserShield,
  FaCloud,
  FaChartLine,
} from "react-icons/fa";

const features = [
  {
    icon: <FaCloud size={24} />,
    title: "See What Is Working and What Is Holding You Back",
    text: "Review Microsoft 365 tenant health, licensing, collaboration, security, governance, and productivity opportunities.",
  },
  {
    icon: <FaShieldAlt size={24} />,
    title: "Prioritise the Right Improvements",
    text: "Identify what to build, optimise, secure, automate, or govern first so investment goes into the changes that create business value.",
  },
  {
    icon: <FaUserShield size={24} />,
    title: "Improve Collaboration and Control",
    text: "Strengthen SharePoint, Teams, OneDrive, identity, access, file ownership, user lifecycle, and governance practices.",
  },
  {
    icon: <FaChartLine size={24} />,
    title: "Turn Microsoft Cloud Into a Growth Platform",
    text: "Create a cleaner, safer and more productive digital workplace that supports growth, remote work, automation, and compliance conversations.",
  },
];

const OurFeatures = () => {
  return (
    <section className="cl-features-section">
      <div className="container">
        <div className="cl-features-layout">
          <div className="cl-features-left">
            <span className="cl-features-badge">
              What Leaders Get From the Health Check
            </span>

            <h2>
              A Clear Microsoft Cloud Improvement Roadmap, Not a Vague IT Conversation
            </h2>

            <p>
              Business leaders need to know whether Microsoft 365 is helping
              the organisation work better, collaborate safely, reduce risk,
              control cost, and prepare for future growth.
            </p>

            <div className="cl-features-points">
              <span>Microsoft 365 tenant, licensing and productivity review</span>
              <span>SharePoint, Teams, OneDrive and workflow opportunities</span>
              <span>Identity, security, governance and compliance priorities</span>
              <span>Plain-English transformation roadmap for leaders</span>
            </div>

            <div className="cl-features-action">
              <Link to="/contact" className="default-btn">
                Request Microsoft 365 Health Check
              </Link>
            </div>
          </div>

          <div className="cl-features-right">
            <div className="cl-features-grid">
              {features.map((item, index) => (
                <div className="cl-feature-card" key={index}>
                  <div className="cl-feature-icon">{item.icon}</div>

                  <h3>{item.title}</h3>

                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurFeatures;
